import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ExperimentContext from './ExperimentContext';

const Variation = ({ children, variationKey }) => {
  const { selectedVariation } = useContext(ExperimentContext);
  if (!!selectedVariation && selectedVariation === variationKey) {
    return <>{children}</>;
  }
  return null;
};

Variation.propTypes = {
  children: PropTypes.node.isRequired,
  variationKey: PropTypes.string.isRequired,
};

export default Variation;
